export const SETTINGS = {
  RENDERER_PARAM: {
    clearColor: 0xffffff,
  },
  camera: {
    fov: 30,
    aspect: 1,
    near: 0.1,
    far: 1000,
    position: {
      x: 5,
      y: 5,
      z: 5,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
  sunLight: {
    color: 0xffffff,
    intensity: 1.0,
    position: {
      x: 5,
      y: 10,
      z: 0,
    },
  },
  ambientLight: {
    color: 0xffffff,
    intensity: 1.2,
  },
};
